import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../consts/api";

export const useAcceptSurchargeAgreement = (clinicId, options = {}) => {
  const res = useMutation(
    () => http.post(HTTP_ENDPOINTS.customTax.acceptSurchargeAgreement(clinicId)),
    { ...options },
  );

  return res;
};
